export default "__VITE_ASSET__CZ7bE0jn__";